import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import '../styles/project-carousel.css';

export interface ProjectCarouselData {
    image: string;
    caption: string;
}

export function ProjectCarousel({ data, title, description }: { data: ProjectCarouselData[], title: string, description: string }) {
    return (
        <div className="carousel-container">
            <Carousel className="project-carousel" infiniteLoop={true} autoPlay={true} showThumbs={false} showStatus={false} showArrows={true} >
                {
                    data.map((item, index) => (
                        <div key={index}>
                            <img src={item.image} alt="item.image" className="work-carousel-image" />
                            {/* <p className="work-legend">{item.caption}</p> */}
                        </div>
                    ))
                }
            </Carousel>
            <div className="carousel-title">{title}</div>
            <div className="carousel-desc">{description}</div>
        </div>
    );
}
